/*
 * Motion layer. Two things CSS genuinely cannot do, and nothing else.
 *
 *  1. Spring-eased reveals with real stagger. The CSS fallback caps at four
 *     children and uses fixed delays; this runs any length with one spring.
 *  2. Scroll-linked parallax. Two images moving at different rates is what
 *     reads as depth, and it can only be driven by scroll position.
 *
 * Everything else — hover, press, focus, the modal — stays in CSS, where it
 * costs nothing and cannot break.
 *
 * Loads after the CSS reveal system and takes it over by marking <html>. If
 * this file fails to parse or the library never arrives, the CSS path is still
 * live and the page still reveals. That is the point of the handover flag.
 */
(function () {
  var M = window.Motion;
  if (!M || !matchMedia('(prefers-reduced-motion: no-preference)').matches) return;

  var animate = M.animate;
  var inView = M.inView;
  var scroll = M.scroll;

  // Taking over the reveal means CSS stops revealing anything. If this script
  // then throws, the page is permanently invisible — so the handover is guarded
  // and there is a hard failsafe behind it. A missing animation is a nuisance;
  // a blank page is a broken site.
  var root = document.documentElement;
  function surrender() {
    root.removeAttribute('data-kl-js');
  }
  root.setAttribute('data-kl-js', '');
  addEventListener('error', surrender);
  // Nothing should take three seconds. If the reveals have not run by then,
  // something went wrong that no error handler caught.
  setTimeout(function () {
    var stuck = document.querySelector('.kl-reveal');
    if (stuck && getComputedStyle(stuck).opacity === '0' && stuck.getBoundingClientRect().top < innerHeight) {
      surrender();
    }
  }, 3000);

  var SPRING = { type: 'spring', stiffness: 120, damping: 20, mass: 0.9 };

  function reveal(el, children) {
    var targets = children ? Array.prototype.slice.call(el.children) : [el];
    if (!targets.length) return;
    animate(
      targets,
      { opacity: [0, 1], transform: ['translateY(22px)', 'translateY(0px)'] },
      Object.assign({}, SPRING, { delay: M.stagger ? M.stagger(0.07) : 0 })
    );
  }

  try {
    document.querySelectorAll('.kl-reveal').forEach(function (el) {
      inView(el, function () { reveal(el, false); }, { amount: 0.25 });
    });

    document.querySelectorAll('.kl-reveal-group').forEach(function (el) {
      inView(el, function () { reveal(el, true); }, { amount: 0.2 });
    });
  } catch (e) {
    surrender();
    return;
  }

  /*
   * Parallax. The image is already oversized by the CSS (object-fit: cover on a
   * fixed aspect box), so shifting it inside its own frame reveals no edge.
   * Rates are deliberately small — 6% of the frame at most. Anything larger
   * fights the reader on a trackpad.
   */
  function parallax(selector, distance) {
    document.querySelectorAll(selector).forEach(function (img) {
      var frame = img.parentElement;
      if (!frame) return;
      frame.style.overflow = 'hidden';
      img.style.willChange = 'transform';
      img.style.transform = 'scale(1.12)';

      scroll(
        function (progress) {
          var offset = (progress - 0.5) * distance * 2;
          img.style.transform = 'scale(1.12) translate3d(0,' + offset + '%,0)';
        },
        { target: frame, offset: ['start end', 'end start'] }
      );
    });
  }

  // Parallax is pure decoration, so it gets its own try: a failure here must
  // not take the reveals down with it.
  try {
  // Different rates on the two story frames is the whole depth effect.
  parallax('.kl-story__back img', 5);
  parallax('.kl-story__front img', -3.5);
  parallax('.kl-spot__media img', 4);
  parallax('.kl-callouts__figure img', 3);
  parallax('.kl-cats__figure img', 3.5);
  } catch (e) {
    /* decoration only */
  }
})();
